import { getFontAwesomeIcon } from "../../../../../../utils";
import { SupplyPortal, GenericList } from "../../../../../ui";
import { QuickActionField } from "../../../../../../globalTypes";
import { ModalType } from "../../../../../../pages/Orders/view/ApprovalView/types";

interface ActionListProps {
	containerId: string;
	activeRowUuid: string;
	setQuickMenuVisible: (visible: string | null) => void;
	fields: QuickActionField[];
	setActiveModal: (modalType: ModalType) => void;
}

const ActionList: React.FC<ActionListProps> = ({
	containerId,
	setQuickMenuVisible,
	fields,
	setActiveModal,
}) => {
	const visibleFields = fields.filter((field) => field.isVisible);

	const renderItem = (item: QuickActionField, index?: number) => {
		return (
			<div
				className={`hover:cursor hover:bg-supply-blue-50 flex items-center ${
					index !== undefined && index > 0
						? "border-t border-gray-200"
						: ""
				}`}
				onClick={(e) => {
					e.stopPropagation();
					setQuickMenuVisible(null);
					setActiveModal(item.valueKey as string);
				}}
			>
				<span
					className={`w-6 text-${item.prefixColor} flex-shrink-0 text-center`}
				>
					{item.prefix &&
						item.prefixWeight &&
						getFontAwesomeIcon(item.prefix, item.prefixWeight)}
				</span>
				<span className="ml-2 text-navy-500 font-omnes-regular">
					{item.label}
				</span>
			</div>
		);
	};

	return (
		<>
			{/* Modal overlay to close the action menu by clicking outside */}
			<SupplyPortal containerId={containerId}>
				<div className="opacity-0 size-full absolute z-0 top-0"></div>
			</SupplyPortal>

			<div className="relative z-10">
				<GenericList<QuickActionField>
					containerClasses="bg-white w-40 border-1 border-navy-200 rounded-lg z-50 text-sm"
					data={visibleFields}
					renderItem={renderItem}
					listType="unordered"
				/>
			</div>
		</>
	);
};

export default ActionList;
